import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { compareValuesOperator } from './compareValuesOperator.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ConditionalComponent = class extends Mixins(MagicConfigMixin) {
  get matches() {
    return compareValuesOperator(this.value1, this.condition, this.value2);
  }
};
__decorateClass([
  Prop({ type: String, default: "" })
], ConditionalComponent.prototype, "value1", 2);
__decorateClass([
  Prop({ type: String, default: "" })
], ConditionalComponent.prototype, "value2", 2);
__decorateClass([
  Prop({ type: String, default: "does exist" })
], ConditionalComponent.prototype, "condition", 2);
ConditionalComponent = __decorateClass([
  Component({ name: "ui-conditional" })
], ConditionalComponent);

export default ConditionalComponent;
